import { HttpAuth } from '../../config/Http'
import { changeNotify } from './notify.action'

export const actionTypes = {
    INDEX: 'SHOPPING_INDEX',
    SUCCESS: 'SHOPPING_SUCCESS',
    ERROR: 'SHOPPING_ERROR'
}

export const success = (payload) => ({
    type: actionTypes.SUCCESS,
    payload
})

export const error = (payload) => ({
    type: actionTypes.ERROR,
    payload
})

// INDEX

export const indexResponse = (payload, isLoadMore) => ({
    type: actionTypes.INDEX,
    payload,
    isLoadMore
})

// INDEX

export const index = (user_id, query, isLoadMore) => dispatch => {
    
    return HttpAuth.post('/shopping/'+ user_id, query)
            .then(res => typeof res !== 'undefined' && dispatch(indexResponse(res.data, isLoadMore)))
            .catch(erro => {
                if(erro.response) {
                    dispatch(changeNotify({
                        open: true,
                        msg: erro.response.data.msg,
                        class: erro.response.data.class
                    }))
                    dispatch(success(true))
                }
            })
}